export default __webpack_public_path__ + "static/media/csg.5235f8a4.svg";